import './history-points.scss'

import { Skeleton } from '@acctglobal/skeleton'
import React from 'react'

import { formattedDate } from '../../../../../../../utils/date/formattedDate'
import { useCardContext } from '../../../../../../contexts/CardContext'
import { StatusMessage } from '../../../../../ui/StatusMessage'
import { NotResultsHistoryPoints } from '../NotResultsHistoryPoints'

export const HistoryPoints = () => {
  const { historyPoints } = useCardContext()

  if (historyPoints?.error) {
    return <StatusMessage />
  }

  if (historyPoints?.loading) {
    return (
      <div className="club-card-user-history-points">
        <Skeleton
          table={{ rows: 5, columns: 1 }}
          height={68}
          margin={0}
          backgroundColor="var(--color-grayScale-faded)"
        />
      </div>
    )
  }

  if (!historyPoints?.loading && !historyPoints?.data?.length) {
    return <NotResultsHistoryPoints />
  }

  return (
    <>
      <div className="club-card-user-history-points">
        <div className="history-points-header">
          <ul>
            <li className="history-points-header-item">Data</li>
            <li className="history-points-header-item">Operação</li>
            <li className="history-points-header-item">Valor</li>
          </ul>
        </div>
        <div className="history-points-items">
          {historyPoints?.data?.map((historyPointItem, index) => (
            <div key={index} className="history-points-item">
              <p className="history-points-item-text">
                {formattedDate(historyPointItem?.date)}
              </p>
              <p className="history-points-item-text">
                {historyPointItem?.typeTransaction}
              </p>
              <p
                className={`history-points-item-text ${historyPointItem?.points < 0 ? 'debit' : 'credit'}`}
              >
                {`${historyPointItem?.points >= 0 ? '+' : ''}${historyPointItem?.points} pts.`}
              </p>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}
